import React from 'react';

export default class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error, info) {
    if (process.env.NODE_ENV !== 'production') console.error('Rayat screen error', error, info);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <main className="min-h-screen bg-gray-100 flex items-center justify-center p-6">
        <section className="max-w-md w-full bg-white border border-gray-200 rounded-xl p-6 text-center shadow-sm" role="alert">
          <h1 className="text-xl font-bold text-slate-900">Something went wrong</h1>
          <p className="text-sm text-slate-600 mt-2">Your account and saved information are safe. Reload the screen and try again.</p>
          <button type="button" className="mt-5 px-5 py-3 rounded-lg bg-slate-800 text-white font-semibold" onClick={() => this.setState({ failed: false })}>Reload screen</button>
        </section>
      </main>
    );
  }
}
